import { FC, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  RiArrowDropDownLine,
  RiArrowDropUpLine,
} from "react-icons/ri";
import { EvmcType } from "../../../models/EvmcSelections";

interface SimpleDropDownListProps {
  handleSelection: (newSelection: string) => void;
  values: string[];
  selectedValue: string;
  type: EvmcType;
  id: string;
  ariaLabel?: string;
  ariaDescribedby?: string;
  ariaDetails?: string;
}

const SimpleDropDownList: FC<SimpleDropDownListProps> = ({
  handleSelection,
  values,
  selectedValue,
  type,
  id,
  ariaLabel,
  ariaDescribedby,
  ariaDetails,
}) => {
  const [show, setShow] = useState(false);
  const { t } = useTranslation();
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    setShow(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [type]);

  useEffect(()=>{
    const handleClickOutside = (event:Event) => {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        setShow(false); 
      }
    };
    document.addEventListener('click', handleClickOutside, true);
    return () => {
      document.removeEventListener('click', handleClickOutside, true);
    };
  },[]);
  
  const change = (newSelection: string) => {
    handleSelection(newSelection);
    setShow(false);
  };

  return (
    <>
      <div ref={ref} className="select-box-simple-box">
        <div className="select-box--container active">
          <div
            className="select-box--selected-item"
            onClick={() => setShow(!show)}
          >
            <div className="display-selection active" title={t(`evmc-filters-${selectedValue}`) || ""}>
              {t(`evmc-filters-${selectedValue}`)}
            </div>
            <div className="select-box--arrow">
              <button 
                type="button"
                id={ id + "-btn" }
                aria-controls={ id + "-tooltip" }
                aria-label={ ariaLabel }
                aria-describedby={ ariaDescribedby }
                aria-details={ ariaDetails }
              >
                {show ? (
                  <RiArrowDropUpLine
                    style={{ color: "#000000", fontSize: "30px" }}
                  />
                ) : (
                  <RiArrowDropDownLine
                    style={{ color: "#000000", fontSize: "30px" }}
                  />
                )}
              </button>
            </div>
          </div>
        </div>
        <div
          style={{
            display: show ? "block" : "none",
            padding: "0px",
          }}
          className="select-box--items simple"
        >
          <div 
            className="simple-items-list" 
            role="list"
            id={ id + "-tooltip" }
            aria-label={ ariaLabel }
            aria-describedby={ ariaDescribedby }
            aria-details={ ariaDetails }
          >
            {values.map((item) => (
              <div key={item} role="listitem">
                <li tabIndex={0} onClick={() => change(item)} onKeyDown={(e) => {
                  if (e.code.toLowerCase() === "enter" || e.code.toLowerCase() === "space") change(item);
                }}>
                  {t(`evmc-filters-${item}`)}
                </li>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};
export default SimpleDropDownList;
